import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getTableLayerId } from "../../ducks/table/selectors";
import { setTableLayerId } from "../../ducks/table/table";

export const useTableLayerId = (): [string, (layerId?: string) => void] => {
  const dispatch = useDispatch();
  const tableLayerId = useSelector(getTableLayerId);

  const update = useCallback(
    (layerId: string) => {
      dispatch(setTableLayerId(layerId));
    },
    [dispatch],
  );

  return [tableLayerId, update];
};
